// import CCEverywhere from "https://cc-embed.adobe.com/sdk/v4/CCEverywhere.js";
// const CCEverywhere = await import(
//   "https://cc-embed.adobe.com/sdk/v4/CCEverywhere.js"
// );

import { store } from "../store";
import { IMS } from "./imsService";

const CDN_URL = "https://cc-embed.adobe.com/sdk/1p/v4/CCEverywhere.js";

// let CCEverywhere = null;
let expressSDK;
let isInitializing = false;

const load = async () => {
  if (window.CCEverywhere) {
    return window.CCEverywhere;
  }

  await import(CDN_URL);

  while (!window.CCEverywhere) {
    // wait for CCEverywhere to be available
    await new Promise((resolve) => setTimeout(resolve, 100));
  }

  return window.CCEverywhere;
};

export const initialize = async () => {
  if (expressSDK) {
    return expressSDK;
  }

  if (isInitializing) {
    // Wait until the initialization is complete
    while (!expressSDK) {
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
    return expressSDK;
  }

  isInitializing = true;

  await load();

  const options = {
    clientId: "f2898953e7e04547b7b1854c02d2409b",
    appName: "Be Story",
    authProvider: async () => {
      // Get fresh access token from IMS (handles refresh if needed)
      const accessToken = await IMS.getAccessToken();
      const profile = store.getState().ims.profile;
      
      return {
        mode: "ims-jump",
        config: {
          accessToken: accessToken,
          userId: profile?.userId || profile?.id,
        },
      };
    },
  };

  expressSDK = await window.CCEverywhere.initialize(options, {
    skipBrowserSupportCheck: true,
  });

  return expressSDK;
};

export const getEditor = async () => {
  const { editor } = await initialize();

  return editor;
};
